module.exports = "https://r.nearpod.com/assets/media/image/sub_plan_icon-01c7877f1232ba32ae119fb6bc966564.svg";